import { render, staticRenderFns } from "./InsightMsgs.vue?vue&type=template&id=d84c241e&"
import script from "./InsightMsgs.vue?vue&type=script&lang=js&"
export * from "./InsightMsgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports